import { toSentenceCase } from '@noths/polaris-client-utils';
import type { NonNullableLink } from '@noths/polaris-dev-ts-types';
import { build as buildTaxonomyPlpUrl } from '@noths/polaris-product-listings-urls';

import type { ProductState } from 'src/redux/product/types';

const TAXONOMY_PLP_BASE_PATH = '/shop/all';
// for the purpose of building breadcrumb links, the specific alias values do not matter.
const TAXONOMY_ALIASES = ['l1', 'l2', 'l3', 'l4'] as const;
const TAXONOMY_HOME_BREADCRUMB: NonNullableLink = {
  href: '/',
  rel: '/',
  title: 'Homepage',
};

export const getTaxonomyBreadcrumbsLinks = (product: ProductState): NonNullableLink[] => {
  const links: NonNullableLink[] = [TAXONOMY_HOME_BREADCRUMB];
  const taxonomySelections: Array<{ alias: (typeof TAXONOMY_ALIASES)[number]; value: string }> = [];

  for (let level = 1; level <= TAXONOMY_ALIASES.length; level++) {
    const value = product.attributes?.[`productTypeLevel${level}`];

    if (typeof value !== 'string' || value.trim() === '') {
      break;
    }

    taxonomySelections.push({
      alias: TAXONOMY_ALIASES[level - 1],
      value,
    });

    const href = buildTaxonomyPlpUrl({
      basePath: TAXONOMY_PLP_BASE_PATH,
      taxonomyAliases: TAXONOMY_ALIASES,
      filters: taxonomySelections.map(({ alias, value: taxonomyValue }) => ({
        alias,
        values: [taxonomyValue],
      })),
    });

    links.push({
      href,
      rel: href,
      title: toSentenceCase(value),
    });
  }

  return links;
};
